// extracted by css-extract-rspack-plugin
export default {"hidden":"_1b80a521","bold":"_b7857fce"};